import { IPO } from "../actionTypes";
import { getPlaceModifyBid, getIpoDetails, cancelPlaceBid, termConditionIpo } from '../../apis/index';
import { _getCmotsIpos, _getIpos, _getOrderBookDetails } from "../../controllers";
import { deepClone } from "../../utils/global_functions";


export const getIPOs = (ipoPayload) => async (dispatch, getState) => {
    //Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - Start
    const bIsCMOT = deepClone(getState()?.ipo?.isCMOT);
    if (bIsCMOT) {
        // WIPP
        var objResp = await _getCmotsIpos(ipoPayload);

    } else {
        objResp = await _getIpos(ipoPayload);
    }
    //Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - End
    if (objResp?.status) {

        dispatch(getOngoingIPOsSuccess(objResp?.data?.currentIPOData));
        dispatch(getFutureIPOsSuccess(objResp?.data?.futureIPOData));
        dispatch(getPastIPOsSuccess(objResp?.data?.pastIPOData));
    } else {
        dispatch(getOngoingIPOsFailure([]));
        dispatch(getFutureIPOsFailure([]));
        dispatch(getPastIPOsFailure([]));

    }
    return Promise.resolve(objResp?.data?.currentIPOData);


};

export const getOngoingIPOsSuccess = (objResp) => {
    return { type: IPO.GET_ONGOING_IPO_SUCCESS, payload: objResp };
};

export const getOngoingIPOsFailure = (payload) => {
    return { type: IPO.GET_ONGOING_IPO_FAILURE, payload };
};

export const getFutureIPOsSuccess = (objResp) => {
    return { type: IPO.GET_FUTURE_IPO_SUCCESS, payload: objResp };
};

export const getFutureIPOsFailure = (payload) => {
    return { type: IPO.GET_FUTURE_IPO_FAILURE, payload };
};
export const getPastIPOsSuccess = (objResp) => {
    return { type: IPO.GET_PAST_IPO_SUCCESS, payload: objResp };
};

export const getPastIPOsFailure = (payload) => {
    return { type: IPO.GET_PAST_IPO_FAILURE, payload };
};
export const getIpoDetailsInfo = (payload) => async (dispatch) => {
    try {

        const objResp = await getIpoDetails(payload);
        const IPODetailslist = objResp?.data.data;
        dispatch(getIposDetailsSuccess(IPODetailslist));
        return Promise.resolve(objResp); //ManasaB : 19/03/2024 : Place Bid data issue

    } catch (error) {
        console.log(error);
        dispatch(getIposDetailsFailure([]));
        return Promise.reject(error);//ManasaB : 19/03/2024 : Place Bid data issue
    }

};
export const getIposDetailsSuccess = (objResp) => {
    return { type: IPO.GET_IPO_DETAILS_SUCCESS, payload: objResp };
};

export const getQuickBid = (objResp) => {
    return { type: IPO.GET_IPO_QUICK_BID, payload: objResp };
};
export const getIposDetailsFailure = (objResp) => {
    return { type: IPO.GET_IPO_DETAILS_FAILURE, payload: objResp };
};

//getPlaceBidDetails
export const getPlaceModifyBidDetails = (payload) => async (dispatch) => {
    try {
        const objResp = await getPlaceModifyBid(payload);
        dispatch(getPlaceModifyBidSuccess(objResp.data));
        return Promise.resolve(objResp.data);

    } catch (error) {
        console.log(error);
        dispatch(getPlaceModifyBidFailure(error.response.data));
        return Promise.resolve(error.response.data);
    }

};
export const getPlaceModifyBidSuccess = (objResp) => {
    return { type: IPO.GET_PLACEMODIFY_BID_SUCCESS, payload: objResp };
};

export const getPlaceModifyBidFailure = (objResp) => {
    return { type: IPO.GET_PLACEMODIFY_BID_FAILURE, payload: objResp };
};

export const getOrderBookDetails = (orderBookPayload) => async (dispatch) => {
    const objResp = await _getOrderBookDetails(orderBookPayload);
    if (objResp?.status) {
        dispatch(getOrderBookSuccess(objResp?.data));
    } else {
        dispatch(getOrderBookFailure([]));
    }
};



export const getOrderBookSuccess = (objResp) => {
    return { type: IPO.GET_ORDERBOOK_SUCCESS, payload: objResp };
};

export const getOrderBookFailure = (payload) => {
    return { type: IPO.GET_ORDERBOOK_FAILURE, payload };
};


export const getCancelBidDetails = (payload) => async (dispatch) => {
    try {
        const objResp = await cancelPlaceBid(payload);
        dispatch(cancelPlaceBidSuccess(objResp.data));
        return Promise.resolve(objResp?.data);

    } catch (error) {
        console.log(error);
        dispatch(cancelPlaceBidFailure(error.response.data));
    }

};
export const cancelPlaceBidSuccess = (objResp) => {
    return { type: IPO.GET_CANCELBID_SUCCESS, payload: objResp };
};

export const cancelPlaceBidFailure = (objResp) => {
    return { type: IPO.GET_CANCELBID_FAILURE, payload: objResp };
};

export const getTermsAndConditionIpo = () => async (dispatch) => {
    try {
        const objResp = await termConditionIpo();
        const data = await objResp?.data;
        dispatch(termsAndConditionIpoSuccess(data));
        return Promise.resolve(data);



    } catch (error) {
        console.log(error);
        dispatch(termsAndConditionIpoFailure([]));
    }

};
export const termsAndConditionIpoSuccess = (objResp) => {
    return { type: IPO.GET_TERMS_AND_CONDITION_SUCCESS_IPO, payload: objResp };
};

export const termsAndConditionIpoFailure = (payload) => {
    return { type: IPO.GET_TERMS_AND_CONDITION_FAILURE_IPO, payload };
};

//Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - Start
export const updateIsCMOT = (payload) => {
    return { type: IPO.UPDATE_IS_CMOT, payload };
};
//Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - End